export function getDevice(sku) {

	let device = '';

	const modelCodeToDeviceName = {
        "SM-R950": "Galaxy Watch6 Classic",
        "SM-R955": "Galaxy Watch6 Classic",
        "SM-R960": "Galaxy Watch6 Classic",
        "SM-R965": "Galaxy Watch6 Classic",
        "SM-R930": "Galaxy Watch6",
        "SM-R935": "Galaxy Watch6",
        "SM-R940": "Galaxy Watch6",
        "SM-R945": "Galaxy Watch6",
        "SM-R900": "Galaxy Watch5 Golf Edition",
        "SM-R910": "Galaxy Watch5 Golf Edition",
        "SM-R920": "Galaxy Watch5 Pro",
        "SM-R900": "Galaxy Watch5",
        "SM-R905": "Galaxy Watch5",
        "SM-R910": "Galaxy Watch5",
        "SM-R915": "Galaxy Watch5",
        "SM-R895": "Galaxy Watch4 Classic",
        "SM-R885": "Galaxy Watch4 Classic",
        "SM-R890": "Galaxy Watch4 Classic",
        "SM-R880": "Galaxy Watch4 Classic",
        "SM-R860": "Galaxy Watch4",
        "SM-R177": "Galaxy Buds2",
        "EI-T730": "Galaxy SmartTag Plus",
        "EI-T530": "Galaxy SmartTag",
        "SM-R190": "Galaxy Buds Pro",
        "SM-R510": "Galaxy Buds2 Pro",
        "SM-R220": "Galaxy Fit2",
        "SM-R845": "Galaxy Watch3",
        "SM-R855": "Galaxy Watch3",
        "SM-R840": "Galaxy Watch3",
        "SM-R850": "Galaxy Watch3",
        "SM-R180": "Galaxy Buds Live",
        "SM-R175": "Galaxy Buds Plus",
        "SM-R820": "Galaxy Watch Active2 Bluetooth",
        "SM-R830": "Galaxy Watch Active2 Bluetooth",
        "SM-R825": "Galaxy Watch Active2 LTE",
        "SM-R835": "Galaxy Watch Active2 LTE",
        "SM-R810": "Galaxy Watch 42mm",
        "SM-R815": "Galaxy Watch 42mm",
        "SM-R370": "Galaxy Fit",
        "SM-R500": "Galaxy Watch Active",
        "SM-R170": "Galaxy Buds",
        "SM-R800": "Galaxy Watch",
        "SM-R805": "Galaxy Watch",
        "SM-R760": "Gear S3 frontier",
        "SM-R365": "Gear Fit2",
        "SM-R720": "Gear S2",
        "EE-DV70": "Galaxy Gear",
        "SP-LSP3": "The Freestyle",
        "SP-LSP7": "The Premiere LSP7T Single Laser",
        "SP-LSP9": "The Premiere LSP9T Triple Laser",
        "HW-J651": "HW-J651 Soundbar",
        "HW-N850": "HW-N850 Soundbar",
        "WAM6500": "R6 Wireless Speaker",
        "WAM6501": "R6 Wireless Speaker",
        "WAM7500": "R7 Wireless Speaker",
        "WAM7501": "R7 Wireless Speaker",
        "WAM750": "Shape M7",
        "WAM751": "Shape M7",
        "UBD-K850": "UBD-K8500",
        "VS20A95": "Bespoke Jet Vacuum Cleaner",
        "VC12H40": "VC4000 Canister Vacuum",
        "VR30T80": "Jet Bot 80",
        "VR30T85": "Jet Bot 80 Plus",
        "VR50T95": "Jet Bot 90 AI Plus",
        "VS20T75": "Jet 75 Pet",
        "VS15T70": "Jet 70 Turbo",
        "VR20H90": "VR9000 ROBOT VC",
        "SR20H90": "VR9000 ROBOT VC",
        "VU08H30": "VU3000 Vacuum",

        "SM-A145": "Galaxy A14 4G",
        "SM-A146": "Galaxy A14 4G",
        "SM-A346": "Galaxy A34 5G",
        "SM-A546": "Galaxy A54 5G",
        "SM-A266B": "Galaxy A26 5G",
        "SM-A366B": "Galaxy A36 5G",
        "SM-A566B": "Galaxy A56 5G",
        "SM-A135": "Galaxy A13",
        "SM-A336": "Galaxy A33 5G",
        "SM-A536": "Galaxy A53 5G",
        "SM-A047": "Galaxy A04s",
        "SM-A236": "Galaxy A23 5G",
        "SM-A136": "Galaxy A13 5G",
        "SM-A035": "Galaxy A03",
        "SM-A037": "Galaxy A03",
        "SM-A528": "Galaxy A52s 5G",
        "SM-A025F": "Galaxy A02s",
        "SM-A125": "Galaxy A12",
        "SM-A426": "Galaxy A42 5G",
        "SM-A326": "Galaxy A32 5G",
        "SM-A526": "Galaxy A52 5G",
        "SM-A725": "Galaxy A72",
        "SM-A226": "Galaxy A22 5G",
        "SM-A217": "Galaxy A21s",
        "SM-A415": "Galaxy A41",
        "SM-A315": "Galaxy A31",
        "SM-A516": "Galaxy A51 5G",
        "SM-A166": "Galaxy A16 5G",
        "SM-A166": "Galaxy A16 LTE",
        "SM-A515": "Galaxy A51",
        "SM-A715": "Galaxy A71",
        "SM-A307": "Galaxy A30s",
        "SM-A908": "Galaxy A90 5G",
        "SM-A705": "Galaxy A70",
        "SM-A260": "Galaxy A2 Core",
        "SM-A205": "Galaxy A20e",
        "SM-A405": "Galaxy A40",
        "SM-A805": "Galaxy A80",
        "SM-A105": "Galaxy A10",
        "SM-A305": "Galaxy A30",
        "SM-A505": "Galaxy A50",
        "SM-A510": "Galaxy A5 2016",
        "SM-A530": "Galaxy A8",
        "SM-A750": "Galaxy A7",
        "SM-A300": "Galaxy A3",
        "SM-A500": "Galaxy A5",
        "SM-A320": "Galaxy A3 2017",
        "SM-A520": "Galaxy A5 2017",
        "SM-A600": "Galaxy A6 2018",
        "SM-A920": "Galaxy A9",
        "SM-A356": "Galaxy A35 5G",

        "SM-S911": "Galaxy S23 5G",
        "SM-S916": "Galaxy S23 Plus 5G",
        "SM-S918": "Galaxy S23 Ultra 5G",
        "SM-S901": "Galaxy S22 5G",
        "SM-S906": "Galaxy S22 Plus 5G",
        "SM-S908": "Galaxy S22 Ultra 5G",
        "SM-G990": "Galaxy S21 5G",
        "SM-G991": "Galaxy S21 5G",
        "SM-G996": "Galaxy S21 Plus 5G",
        "SM-G998": "Galaxy S21 Ultra 5G",
        "SM-G780": "Galaxy S20 FE",
        "SM-G781": "Galaxy S20 FE 5G",
        "SM-G980": "Galaxy S20",
        "SM-G981": "Galaxy S20 5G",
        "SM-G986": "Galaxy S20 Plus 5G",
        "SM-G988": "Galaxy S20 Ultra 5G",
        "SM-G973": "Galaxy S10",
        "SM-G975": "Galaxy S10 Plus",
        "SM-G970": "Galaxy S10e",
        "SM-G950": "Galaxy S8",
        "SM-G955": "Galaxy S8 Plus",
        "SM-A310": "Galaxy S7 Edge",
        "SM-G977": "Galaxy S10 5G",
        "SM-N770": "Galaxy S10 Lite",
        "SM-G960": "Galaxy S9",
        "SM-G965": "Galaxy S9 Plus",

        "SM-F721": "Galaxy Z Flip4 5G",
        "SM-F936": "Galaxy Z Fold4 5G",
        "SM-F916": "Galaxy Z Fold 2",
        "SM-F711": "Galaxy Z Flip3 5G",
        "SM-F926": "Galaxy Z Fold3 5G",
        "SM-F707": "Galaxy Z Flip 5G",
        "SM-F700": "Galaxy Z Flip",
        "SM-F907": "Galaxy Fold 5G",

        "SM-M135": "Galaxy M13",
        "SM-M336": "Galaxy M33 5G",
        "SM-M536": "Galaxy M53 5G",
        "SM-M236": "Galaxy M23 5G",
        "SM-M225": "Galaxy M22",
        "SM-M526": "Galaxy M52 5G",
        "SM-M325": "Galaxy M32",
        "SM-M127": "Galaxy M12",
        "SM-M515": "Galaxy M51",
        "SM-M317": "Galaxy M31s",
        "SM-M115": "Galaxy M11",
        "SM-N960": "Galaxy Note9",

        "SM-N980": "Galaxy Note20",
        "SM-N981": "Galaxy Note20 5G",
        "SM-N986": "Galaxy Note20 Ultra 5G",
        "SM-N970": "Galaxy Note10",
        "SM-N975": "Galaxy Note10 Plus",
        "SM-N950": "Galaxy Note8",

        "SM-J330": "Galaxy J3 2017",
        "SM-J530": "Galaxy J5 2017",
        "SM-J415": "Galaxy J4 Plus",
        "SM-J600": "Galaxy J6",
        "SM-J610": "Galaxy J6 Plus",
        "SM-T636": "Galaxy Tab Active4 Pro 5G Wi-Fi",
        "SM-X706": "Galaxy Tab S8 5G Wi-Fi",
        "SM-X906": "Galaxy Tab S8 Ultra 5G Wi-Fi",
        "SM-X900": "Galaxy Tab S8 Ultra Wi-Fi",
        "SM-X700": "Galaxy Tab S8 Wi-Fi",
        "SM-X806": "Galaxy Tab S8 Plus 5G Wi-Fi",
        "SM-X800": "Galaxy Tab S8 Plus Wi-Fi",
        "SM-X205": "Galaxy Tab A8 4G Wi-Fi",
        "SM-X200": "Galaxy Tab A8 Wi-Fi",
        "SM-T225": "Galaxy Tab A7 Lite 4G Wi-Fi",
        "SM-T736": "Galaxy Tab S7 FE 5G Wi-Fi",
        "SM-T730": "Galaxy Tab S7 FE Wi-Fi",
        "SM-T505": "Galaxy Tab A7 4G Wi-Fi 2020",
        "SM-T500": "Galaxy Tab A7 Wi-Fi 2020",
        "SM-T220": "Galaxy Tab A7 Lite Wi-Fi",
        "SM-T875": "Galaxy Tab S7 4G Wi-Fi",
        "SM-T870": "Galaxy Tab S7 Wi-Fi",
        "SM-T976": "Galaxy Tab S7 Plus 5G Wi-Fi",
        "SM-T970": "Galaxy Tab S7 Plus Wi-Fi",
        "SM-T580": "Galaxy Tab A6 4G Wi-Fi",
        "SM-T585": "Galaxy Tab A6 4G Wi-Fi",
        "SM-T515": "Galaxy Tab A 10.1 4G Wi-Fi 2019",
        "SM-T290": "Galaxy Tab A 8.0 Wi-Fi 2019",
        "SM-T865": "Galaxy Tab S6 4G Wi-Fi",
        "SM-T867": "Galaxy Tab S6 4G Wi-Fi",
        "SM-T295": "Galaxy Tab A 8.0 4G Wi-Fi 2019",
        "SM-T297": "Galaxy Tab A 8.0 4G Wi-Fi 2019",
        "SM-P355": "Galaxy Tab A",
        "SM-T387": "Galaxy Tab A",
        "SM-T587": "Galaxy Tab A",
        "SM-T280": "Galaxy Tab A",
        "SM-T555": "Galaxy Tab A",
        "SM-T550": "Galaxy Tab A",
        "SM-T355": "Galaxy Tab A",
        "SM-P555": "Galaxy Tab A",
        "SM-P550": "Galaxy Tab A",
        "SM-T725": "Galaxy Tab S5e 4G Wi-Fi",
        "SM-T835": "Galaxy Tab S4 10.5 4G Wi-Fi",
        "SM-T830": "Galaxy Tab S4 Wi-Fi only",
        "SM-W703": "Galaxy TabPro S",
        "SM-T595": "Galaxy Tab A 10.5 4G Wi-Fi",
        "SM-T590": "Galaxy Tab A 10.5 Wi-Fi",
        "SM-T575": "Galaxy Tab Active3",
        "SM-T720": "Galaxy Tab S5e Wi-Fi",
        "SM-P615": "Galaxy Tab S6 Lite 4G Wi-Fi 2022",
        "SM-P613": "Galaxy Tab S6 Lite Wi-Fi 2022",
        "SM-T860": "Galaxy Tab S6 Wi-Fi",
        "SM-X626B": "Galaxy Tab S10 FE Plus 5G Wi-Fi",
        "SM-X620": "Galaxy Tab S10 FE Plus Wi-Fi",
        "SM-X526B": "Galaxy Tab S10 FE 5G Wi-Fi",
        "SM-X520": "Galaxy Tab S10 FE Wi-Fi",


        "SM-S921": "Galaxy S24",
        "SM-S926": "Galaxy S24 Plus",
        "SM-S928": "Galaxy S24 Ultra",
        "SM-S721": "Galaxy S24 FE",
        "SM-S931": "Galaxy S25",
        "SM-S936": "Galaxy S25 Plus",
        "SM-S938": "Galaxy S25 Ultra",
        "SM-S711": "Galaxy S23 FE",
        "SM-F946": "Galaxy Z Fold5 5G",
        "SM-F731": "Galaxy Z Flip5 5G",
        "SM-X710": "Galaxy Tab S9 Wi-Fi",
        "SM-X716": "Galaxy Tab S9 5G Wi-Fi",
        "SM-X810": "Galaxy Tab S9 Plus Wi-Fi",
        "SM-X816": "Galaxy Tab S9 Plus 5G Wi-Fi",
        "SM-X910": "Galaxy Tab S9 Ultra Wi-Fi",
        "SM-X916": "Galaxy Tab S9 Ultra 5G Wi-Fi",
        "SM-R930": "Galaxy Watch6",
        "SM-R935": "Galaxy Watch6",
        "SM-R940": "Galaxy Watch6 Classic",
        "SM-R945": "Galaxy Watch6 Classic",
        "SM-G556": "Galaxy XCover7",
        "SM-X306": "Galaxy Tab Active5",
        "SM-R861": "Galaxy Watch FE",
        "HW-B750": "2024 B-Series soundbars",
        "HW-B650": "2024 B-Series soundbars",
        "HW-Q700": "2024 Q-Series soundbars",
        "HW-Q800": "2024 Q-Series soundbars",
        "HW-Q930": "2024 Q-Series soundbars",
        "HW-Q990": "2024 Q-Series soundbars",
        "HW-Q990": "2024 Q-Series soundbars",
        "HW-S61D": "2024 S-Series soundbars",
        "HW-S701": "2024 S-Series soundbars",
        "HW-S801": "2024 S-Series soundbars",
        "HW-Q600": "HW-Q600C Soundbar",
        "HW-Q60C": "2023 HW-Q60C",
        "HW-Q700": "HW-Q700C Soundbar",
        "HW-Q800": "HW-Q800C Soundbar",
        "HW-Q930": "HW-Q930C Soundbar",
        "HW-Q990": "2023 HW-Q990C",
        "HW-B550": "2022 HW-B550",
        "HW-B650": "2022 HW-B650",
        "HW-S50B": "2022 HW-S50B",
        "HW-S60B": "2022 HW-S60B",
        "HW-S800": "2022 HW-S800B Series",
        "SM-X110": "Galaxy Tab A9 Wi-Fi",
        "SM-X115": "Galaxy Tab A9 4G Wi-Fi",
        "SM-X210": "Galaxy Tab A9 Plus Wi-Fi",
        "SM-X216": "Galaxy Tab A9 Plus 5G Wi-Fi",
        "SM-F956": "Galaxy Z Fold6",
        "SM-F741": "Galaxy Z Flip6",
        "SM-Q500": "Galaxy Ring",
        "SM-L305": "Galaxy Watch7",
        "SM-L315": "Galaxy Watch7",
        "SM-L705": "Galaxy Watch Ultra",
        "SM-R530": "Galaxy Buds3",
        "SM-R630": "Galaxy Buds3 Pro",
        "HW-B430": "HW-B430 2.1Ch Soundbar",
        "HW-B450": "HW-B450 2.1ch Soundbar",
        "HW-Q600B": "HW-Q600B 3.1.2ch Soundbar",
        "HW-Q60B": "HW-Q60B 3.1ch Soundbar",
        "HW-Q990B": "HW-Q990B"
	};

	$.each(modelCodeToDeviceName, function(key, value) {


        if (sku.includes(key)) {
	    	device = value;
	    	return false;
	    }


	});

	return device
}